import Vue from 'vue'
import BootstrapVue from 'bootstrap-vue'

import Overview from './Overview'
import i18n from './../i18n'
import { config } from '../../util'

Vue.config.productionTip = false

Vue.use(BootstrapVue)

export default selector => {
  const el = typeof selector === 'string' ? document.querySelector(selector) : selector

  const data = { ...el.dataset }
  let warehouses = []
  let activities = []

  try {
    warehouses = data.warehouses ? JSON.parse(data.warehouses) : []
    activities = data.activities ? JSON.parse(data.activities) : []
  } catch (error) {
    console.error('Error parsing data to load upcoming table!', error) // eslint-disable-line no-console
  }

  const locale = data.locale || 'nl-NL'
  config.locale = locale
  i18n(locale)

  new Vue({
    data: {
      locale,
      ...data,
      csrfToken: data.csrfToken,
      warehouses,
      activities
    },
    render: h => h(Overview)
  }).$mount(el)
}
